var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/CompanionWindow.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import CloseIcon from '@material-ui/icons/CloseSharp';
import OpenInNewIcon from '@material-ui/icons/OpenInNewSharp';
import MoveIcon from '@material-ui/icons/DragIndicatorSharp';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import { Rnd } from 'react-rnd';
import MiradorMenuButton from '../containers/MiradorMenuButton';
import ns from '../config/css-ns';
/**
 * CompanionWindow
 */

export var CompanionWindow =
/*#__PURE__*/
function (_Component) {
  _inherits(CompanionWindow, _Component);

  function CompanionWindow() {
    _classCallCheck(this, CompanionWindow);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompanionWindow).apply(this, arguments));
  }

  _createClass(CompanionWindow, [{
    key: "resizeHandles",

    /** */
    value: function resizeHandles() {
      var position = this.props.position;
      var base = {
        bottom: false,
        bottomLeft: false,
        bottomRight: false,
        left: false,
        right: false,
        top: false,
        topLeft: false,
        topRight: false
      };

      if (position === 'right' || position === 'far-right') {
        return _objectSpread({}, base, {
          left: true
        });
      }

      if (position === 'left') {
        return _objectSpread({}, base, {
          right: true
        });
      }

      if (position === 'bottom' || position === 'far-bottom') {
        return _objectSpread({}, base, {
          top: true
        });
      }

      return base;
    }
    /**
     * render
     * @return
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ariaLabel = _this$props.ariaLabel,
          classes = _this$props.classes,
          paperClassName = _this$props.paperClassName,
          id = _this$props.id,
          onCloseClick = _this$props.onCloseClick,
          updateCompanionWindow = _this$props.updateCompanionWindow,
          isDisplayed = _this$props.isDisplayed,
          position = _this$props.position,
          t = _this$props.t,
          windowId = _this$props.windowId,
          title = _this$props.title,
          children = _this$props.children,
          titleControls = _this$props.titleControls,
          size = _this$props.size,
          defaultSidebarPanelWidth = _this$props.defaultSidebarPanelWidth;
      var isBottom = position === 'bottom' || position === 'far-bottom';
      return React.createElement(Paper, {
        className: [classes.root, position === 'bottom' ? classes.horizontal : classes.vertical, classes["companionWindow-".concat(position)], ns("companion-window-".concat(position)), paperClassName].join(' '),
        style: {
          display: isDisplayed ? null : 'none',
          order: position === 'left' ? -1 : null
        },
        square: true,
        component: "aside",
        "aria-label": ariaLabel || title,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        },
        __self: this
      }, React.createElement(Rnd, {
        className: [classes.rnd],
        style: {
          display: 'flex',
          position: 'relative'
        },
        "default": {
          height: isBottom ? 201 : '100%',
          width: isBottom ? 'auto' : defaultSidebarPanelWidth
        },
        disableDragging: true,
        enableResizing: this.resizeHandles(),
        minHeight: 50,
        minWidth: position === 'left' ? 235 : 100,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      }, React.createElement(Toolbar, {
        className: [classes.toolbar, classes.companionWindowHeader, size.width < 370 ? classes.small : null, ns('companion-window-header')].join(' '),
        disableGutters: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83
        },
        __self: this
      }, React.createElement(Typography, {
        variant: "h3",
        className: classes.windowSideBarTitle,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        },
        __self: this
      }, title), position === 'left' ? updateCompanionWindow && React.createElement(MiradorMenuButton, {
        "aria-label": t('openInCompanionWindow'),
        onClick: function onClick() {
          updateCompanionWindow(windowId, id, {
            position: 'right'
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99
        },
        __self: this
      }, React.createElement(OpenInNewIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103
        },
        __self: this
      })) : React.createElement(React.Fragment, null, updateCompanionWindow && React.createElement(MiradorMenuButton, {
        "aria-label": position === 'bottom' ? t('moveCompanionWindowToRight') : t('moveCompanionWindowToBottom'),
        className: classes.positionButton,
        onClick: function onClick() {
          updateCompanionWindow(windowId, id, {
            position: position === 'bottom' ? 'right' : 'bottom'
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: this
      }, React.createElement(MoveIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      })), React.createElement(MiradorMenuButton, {
        "aria-label": t('closeCompanionWindow'),
        className: classes.closeButton,
        onClick: onCloseClick,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119
        },
        __self: this
      }, React.createElement(CloseIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        },
        __self: this
      }))), titleControls && React.createElement("div", {
        className: [classes.titleControls, isBottom ? classes.companionWindowTitleControlsBottom : classes.companionWindowTitleControls, ns('companion-window-title-controls')].join(' '),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 131
        },
        __self: this
      }, titleControls)), React.createElement(Paper, {
        className: classes.content,
        elevation: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145
        },
        __self: this
      }, children)));
    }
  }]);

  return CompanionWindow;
}(Component);
CompanionWindow.defaultProps = {
  ariaLabel: undefined,
  children: undefined,
  defaultSidebarPanelWidth: 235,
  isDisplayed: false,
  onCloseClick: function onCloseClick() {},
  paperClassName: '',
  position: null,
  size: {},
  t: function t(key) {
    return key;
  },
  title: null,
  titleControls: null,
  updateCompanionWindow: undefined
};